import React from "react";

const Page = ({ children, background }) => {
  const style = {
    background,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundBlendMode: "overlay",
  };
  return (
    <div className="page" style={style}>
      {children}
    </div>
  );
};

export default Page;
